import { create } from 'zustand';

// Extend this store if you need!

export interface AppStore {
  canvasLoaded: boolean;
  setCanvasLoaded: (canvasLoaded: boolean) => void;
  timelineCompleted: boolean;
  setTimelineCompleted: (timelineCompleted: boolean) => void;
}

export const useAppStore = create<AppStore>(set => ({
  canvasLoaded: false,
  timelineCompleted: false,
  setCanvasLoaded: (canvasLoaded: boolean) => set(s => ({ ...s, canvasLoaded })),
  setTimelineCompleted: (timelineCompleted: boolean) => set(s => ({ ...s, timelineCompleted }))
}));
